/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root/route'
import { Route as LoginRouteRouteImport } from './routes/login/route'
import { Route as adminXxxRouteImport } from './routes/(admin)/xxx'
import { Route as adminMcpRouteImport } from './routes/(admin)/mcp'
import { Route as strategyIssuerIdPortfolioIDRouteRouteImport } from './routes/(strategy)/$issuerId.$portfolioID/route'

const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const adminXxxRoute = adminXxxRouteImport.update({
  id: '/(admin)/xxx',
  path: '/xxx',
  getParentRoute: () => rootRouteImport,
} as any)
const adminMcpRoute = adminMcpRouteImport.update({
  id: '/(admin)/mcp',
  path: '/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const strategyIssuerIdPortfolioIDRouteRoute =
  strategyIssuerIdPortfolioIDRouteRouteImport.update({
    id: '/(strategy)/$issuerId/$portfolioID',
    path: '/$issuerId/$portfolioID',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRouteRoute
  '/mcp': typeof adminMcpRoute
  '/xxx': typeof adminXxxRoute
  '/$issuerId/$portfolioID': typeof strategyIssuerIdPortfolioIDRouteRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRouteRoute
  '/mcp': typeof adminMcpRoute
  '/xxx': typeof adminXxxRoute
  '/$issuerId/$portfolioID': typeof strategyIssuerIdPortfolioIDRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/login': typeof LoginRouteRoute
  '/(admin)/mcp': typeof adminMcpRoute
  '/(admin)/xxx': typeof adminXxxRoute
  '/(strategy)/$issuerId/$portfolioID': typeof strategyIssuerIdPortfolioIDRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/login' | '/mcp' | '/xxx' | '/$issuerId/$portfolioID'
  fileRoutesByTo: FileRoutesByTo
  to: '/login' | '/mcp' | '/xxx' | '/$issuerId/$portfolioID'
  id:
    | '__root__'
    | '/login'
    | '/(admin)/mcp'
    | '/(admin)/xxx'
    | '/(strategy)/$issuerId/$portfolioID'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LoginRouteRoute: typeof LoginRouteRoute
  adminMcpRoute: typeof adminMcpRoute
  adminXxxRoute: typeof adminXxxRoute
  strategyIssuerIdPortfolioIDRouteRoute: typeof strategyIssuerIdPortfolioIDRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/xxx': {
      id: '/(admin)/xxx'
      path: '/xxx'
      fullPath: '/xxx'
      preLoaderRoute: typeof adminXxxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/mcp': {
      id: '/(admin)/mcp'
      path: '/mcp'
      fullPath: '/mcp'
      preLoaderRoute: typeof adminMcpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(strategy)/$issuerId/$portfolioID': {
      id: '/(strategy)/$issuerId/$portfolioID'
      path: '/$issuerId/$portfolioID'
      fullPath: '/$issuerId/$portfolioID'
      preLoaderRoute: typeof strategyIssuerIdPortfolioIDRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  LoginRouteRoute: LoginRouteRoute,
  adminMcpRoute: adminMcpRoute,
  adminXxxRoute: adminXxxRoute,
  strategyIssuerIdPortfolioIDRouteRoute: strategyIssuerIdPortfolioIDRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
